import { AdditionalDocumentType } from '@/shared/types/additional-document-type';
import { AppointmentCancellationType } from '@/shared/types/appointment-cancellation-type';
import { AppointmentExecutorType } from '@/shared/types/appointment-executor-type';
import { AppointmentNoInstructionType } from '@/shared/types/appointment-no-instruction-type';
import { AppointmentOutcomeType } from '@/shared/types/appointment-outcome-type';
import { AppointmentPaymentStatusType } from '@/shared/types/appointment-payment-status-type';
import { AppointmentProductType } from '@/shared/types/appointment-product-type';
import { AppointmentReasonType } from '@/shared/types/appointment-reason-type';
import { AppointmentType } from '@/shared/types/appointment-type';
import { ClientOriginalSourceType } from '@/shared/types/client-original-source-type';
import { ClientRelationshipType } from '@/shared/types/client-relationship-type';
import { ClientStatusType } from '@/shared/types/client-status-type';
import { ClientTitleType } from '@/shared/types/client-title-type';
import { InteractionLetterType } from '@/shared/types/interaction-letter-type';
import { InteractionOutcomeType } from '@/shared/types/interaction-outcome-type';
import { InteractionType } from '@/shared/types/interaction-type';
import { PartnerPracticeType } from '@/shared/types/partner-practice-type';
import { PowerOfAttorneyType } from '@/shared/types/power-of-attorney-type';
import { WillType } from '@/shared/types/will-type';

export class State {
    public additionalDocumentTypes: Array<AdditionalDocumentType> = [];
    public appointmentCancellationTypes: Array<AppointmentCancellationType> = [];
    public appointmentExecutorTypes: Array<AppointmentExecutorType> = [];
    public appointmentReasonTypes: Array<AppointmentReasonType> = [];
    public appointmentNoInstructionTypes: Array<AppointmentNoInstructionType> = [];
    public appointmentOutcomeTypes: Array<AppointmentOutcomeType> = [];
    public appointmentPaymentStatusTypes: Array<AppointmentPaymentStatusType> = [];
    public appointmentProductTypes: Array<AppointmentProductType> = [];
    public appointmentTypes: Array<AppointmentType> = [];
    public clientOriginalSourceTypes: Array<ClientOriginalSourceType> = [];
    public clientRelationshipTypes: Array<ClientRelationshipType> = [];
    public clientStatusTypes: Array<ClientStatusType> = [];
    public clientTitleTypes: Array<ClientTitleType> = [];
    public interactionLetterTypes: Array<InteractionLetterType> = [];
    public interactionOutcomeTypes: Array<InteractionOutcomeType> = [];
    public interactionTypes: Array<InteractionType> = [];
    public partnerPracticeTypes: Array<PartnerPracticeType> = [];
    public powerOfAttorneyTypes: Array<PowerOfAttorneyType> = [];
    public willTypes: Array<WillType> = [];
}
